//
// StyleAttribute.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var StyleAttribute = {
    ALT_COLOR:0,
    ALT_TEXT_COLOR:1,
    DONUT:2,
    CELL_SEPARATOR:3,
    MATRIX_BORDER:4,
    RING_SIZE:5,
    MIN_HOLE_SIZE:6,
    ALT_ROW_COLOR:7,
    BACKGROUND_COLOR:8,
    BACKGROUND_TRANSPARENCY:9,
    BORDER_COLOR:10,
    BORDER_STYLE:11,
    BORDER_WIDTH:12,
    ARROW_COLOR:13,
    SELECTED_BACKGROUND_COLOR:14,
    SELECTED_COLOR:15,
    ROW_COLOR:16,
    WIDTH:17,
    CAP_STYLE:18,
    COLOR:19,
    CONNECT:20,
    DATA_SKIN:21,
    KPI_SKIN:22,
    DISPLAY_OPTS:23,
    FILL_COLOR:24,
    FILL_TRANSPARENCY:25,
    FILL_GRADIENT_END_COLOR:26,
    FILL_GRADIENT_START_COLOR:27,
    FILL_GRADIENT_NEUTRAL_COLOR:28,
    FILL_SIZE:29,
    FILL_TYPE:30,
    FONT_SIZE:31,
    FONT_FAMILY:32,
    FONT_STYLE:33,
    FONT_WEIGHT:34,
    FRAME_BORDER:35,
    INLAID_TICK_COLOR:36,
    HIGHLIGHT_COLOR:37,
    LINE_COLOR:38,
    LINE_THICKNESS:39,
    LINE_STYLE:40,
    LINE_TRANSPARENCY:41,
    HORIZONTAL_LINE_STYLE:42,
    VERTICAL_LINE_STYLE:43,
    MARKER_COLOR:44,
    MARKER_SIZE:45,
    MARKER_SYMBOL:46,
    MARKER_TRANSPARENCY:47,
    SHADOW_COLOR:48,
    TEXT_ALIGNMENT:49,
    TEXT_COLOR:50,
    TEXT_TRANSPARENCY:51,
    TEXT_DECORATION:52,
    WRAP_TEXT:53,
    THEME:54,
    TICK_WIDTH:55,
    TICK_DISPLAY:56,
    CONFINE_TICK_VALUES:57,
    FILL_FILE:58,
    TRANSPARENCY:59,
    IMAGE_FIT_STYLE:60,
    FILL_GRADIENT_TRANSPARENCY:61,
    X_OFFSET:62,
    Y_OFFSET:63,
    HORIZONTAL_POSITION:64,
    VERTICAL_POSITION:65,
    BUTTON_TYPE:66,
    LINE_INTERPOLATION:67,
    INVALID:68,
    BLEND_START_COLOR:69,
    BLEND_END_COLOR:70,
    BLEND_START_COLOR_FACTOR:71,
    BLEND_END_COLOR_FACTOR:72,
    BLEND_MODE:73,
    GLOW_THICKNESS:74,
    GLOW_BLUR:75,
    GLOW_COLOR_FACTOR:76,
    GLOW_COLOR:77,
    GRID_DISPLAY:78,
    GRID_LAYER:79,
    YAXIS_LABEL_POSITION:80,
    ATTRIBUTE_PRIORITY:81,
    PADDING:82,
    PADDING_LEFT:83,
    PADDING_RIGHT:84,
    PADDING_TOP:85,
    PADDING_BOTTOM:86,
    BAR_LINE_COLOR_TOP:87,
    BAR_FILL_COLOR:88,
    BAR_LINE_COLOR_BOTTOM:89,
    THUMB_FILL_COLOR_DONUT:90,
    THUMB_FILL_COLOR_CENTER:91,
    THUMB_LINE_COLOR:92,
    BACKGROUND_COLOR_SELECTED:93,
    TEXT_COLOR_SELECTED:94,
    ICON:95,
    IMAGE:96,
    DATA_STYLE_REFERENCE:97,
    FILL_PATTERN:98,
    FILL_PATTERN_COLOR:99,
    FILL_PATTERN_TRANSPARENCY:100,
    LINE_THICKNESS_MIN:101,
    LINE_THICKNESS_MAX:102,
    BUBBLE_SIZE_MIN:103,
    BUBBLE_SIZE_MAX:104,
    MARKER_SIZE_MIN:105,
    MARKER_SIZE_MAX:106,
    DISPLAY_RULE_LABEL:107,
    DISPLAY_RULE_VALUE:108,
    DISPLAY_RULE_INDICATOR:109,
    MIN_MARKER_SIZE_GROUPED:110,
    MIN_MARKER_SIZE_UNGROUPED:111,
    TILE_SET:112,
    FIT_WIDTH:113,
    HORIZONTAL_ALIGNMENT:114,
    VERTICAL_ALIGNMENT:115,
    INSET_SIZE:116,
    INSET_ASPECT_RATIO:117,
    INSET_SIZE_MIN:118,
    INSET_SIZE_MAX:119,
    OTHER_SLICE_PERCENT:120,
    MARKER_FILL_COLOR:121,
    MARKER_FILL_TRANSPARENCY:122,
    MARKER_OUTLINE_COLOR:123,
    MARKER_OUTLINE_THICKNESS:124,
    MARKER_OUTLINE_TRANSPARENCY:125,
    PIN_STYLE:126,
    PIN_COLOR:127,
    FOCUS_BACKGROUND:128
};
export default StyleAttribute;
